module.exports = __webpack_public_path__ + "img/expostyle_0961_apple_green_pantone7481c.2e2a9179.jpg";